var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getPreview } from '@debbie/cortex/dist/api/preview';
import { Email, Loading } from '..';
import { parseText, getSubjectContent } from '../../utils/templates';
import { toHtml } from './utils';
const EmailPreview = (props) => {
    const [email, setEmail] = useState(null);
    const lang = useSelector((s) => s.lang);
    const [isLoading, setIsLoading] = useState(false);
    const fetchPreview = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        const email = yield getPreview(props.options.caseId, {
            subject: props.options.subject
                ? getSubjectContent(parseText(toHtml(props.options.subject), lang.mentions))
                : '',
            html: parseText(toHtml(props.options.html), lang.mentions),
        });
        setEmail(Object.assign({}, email));
        setIsLoading(false);
    });
    useEffect(() => {
        fetchPreview();
    }, []);
    if (!email || !email.html) {
        return null;
    }
    return isLoading ? (React.createElement(Loading, { style: { width: '100%', height: '40px' } })) : (React.createElement(Email, { interaction: { details: email }, noToggle: true }));
};
export default EmailPreview;
//# sourceMappingURL=EmailPreview.js.map